module.exports = __webpack_public_path__ + "img/encorafenib.d5c15166.svg";